<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Edit Patient",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         const previous_date = moment().subtract(1, 'days').format("YYYY-MM-DD");
         return {
            title: "Edit Patient",
            items: [
               {
                  text: "Patients",
                  href: "/patients",
               },
               {
                  text: "Edit Patient",
                  active: true,
               },        
            ],

            patient: {
               country_code_id: 1,
               gender: "",
               name: "",
               mobile: "",
               email: "",
               dob: "",
               address: "",
               pincode: "",
               image: "",
            },

            countries: [],
            states: [],

            token: "",
            errors: {},

            image: "",
            preview_image: "",

            today: current_date,
            yesterday: previous_date,
            
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchPatient();
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },


         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchPatient() {
            let url = "api/admin/patient/profile?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.patient = responseData.patient;  
               this.fetchCountryCodes();
               this.fetchStates();
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchStates() {
            let url = "api/getStates";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.states = responseData;
               })
               .catch((err) => console.log(err));
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         updatePatient() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/patient/update";

            let formData = new FormData();
            formData.append("id", this.patient.patient_id); 
            formData.append("name", this.patient.name); 
            formData.append("mobile", this.patient.mobile); 
            formData.append("country_code", this.patient.country_code_id);
             formData.append("age_type", this.patient.age_type); 
            formData.append("age", this.patient.age);  
            formData.append("dob", this.patient.dob); 
            formData.append("gender", this.patient.gender);             
            formData.append("address", this.patient.address); 
            formData.append("state", this.patient.state); 


            if(this.patient.email) {
               formData.append("email", this.patient.email); 
            } else {
               formData.append("email", ""); 
            }           

            if(this.patient.pincode) {
               formData.append("pincode", this.patient.pincode); 
            } else {
               formData.append("pincode", ""); 
            }            

            if(this.image) {
               formData.append("image", this.image); 
            }            
           
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'patients'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updatePatient()">
                        <div class="row">
                           <b-form-group class="col-lg-3 mb-3">
                              <label>Name <span class="text-danger">*</span></label>
                              <b-form-input v-model="patient.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" @keypress="alphaSpacesOnly"></b-form-input>

                              <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="patient.country_code_id">
                                       <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="patient.mobile" @keypress="numbersOnly" maxlength="15" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>                              
                           </b-form-group>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>Email </label>
                              <b-form-input type="email" v-model="patient.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>

                              <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                              <b-form-group class="col-lg-3 mb-3" v-if="patient.age_type == 1">
                           <label>
                              Age <span class="text-danger">*</span>
                              <span class="ml-2">
                                 <a href="#" @click.prevent="patient.age_type = 2">Enter DOB Instead</a>
                              </span>
                           </label>

                           <b-form-input
                              type="number"
                              v-model="patient.age"
                              min="1"
                              class="form-control"
                              :class="{ 'is-invalid': Boolean(errors.age) }"
                           ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>

                           <div class="form-group col-md-3" v-if="patient.age_type == 2">
                              <label>
                                 Date of Birth <span class="text-danger">*</span>
                                 <span class="ml-2">
                                    <a href="#" @click.prevent="patient.age_type = 1">Enter Age Instead</a>
                                 </span>
                              </label>    
                              <input type="date" v-model="patient.dob" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.dob) }" :max="yesterday"/>

                              <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>Gender <span class="text-danger">*</span></label>
                              <select class="form-control" v-model="patient.gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                 <option :value="null">Select</option>
                                 <option value="1">Male</option>
                                 <option value="2">Female</option>
                                 <option value="3">Others</option>
                              </select>

                              <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>Pincode</label>
                              <b-form-input v-model="patient.pincode" v-bind:class="{ 'is-invalid': Boolean(errors.pincode) }" @keypress="numbersOnly" maxlength="6"></b-form-input>

                              <div v-for="(val, index) in errors.pincode" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>State <span class="text-danger">*</span></label>
                               <select class="form-control" v-model="patient.state">
                                 <option :value="state.name" v-for="state in states" :key="state.id">{{state.name}}</option>
                              </select>
                           </b-form-group>

                           <b-form-group class="col-lg-3 mb-3">
                              <label>Address <span class="text-danger">*</span></label>
                              <b-form-textarea v-model="patient.address" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></b-form-textarea>

                              <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                                                                           
                        </div>

                        <!-- <div class="row">

                           <b-form-group class="col-lg-12">
                              <label>Profile Image <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label><br>
                              
                              <a href="#" target="_blank" v-if="patient.image">
                                 <img :src="$image_url + patient.image" alt="Profile Image" class="avatar-md mb-2">
                              </a>   
                           </b-form-group>

                           <b-form-group class="col-lg-4 mb-3">
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <p class="small">(Leave this field empty if you don't want to change the image)</p>
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>
                           
                        </div> -->

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                                 <router-link :to="{ name: 'patients' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
